import { useSettingsStore } from '@/stores/SettingsStore.ts';
import { Hotkey } from '@/types/Hotkey.ts';
import { getHotkeyLabel } from '@/components/hotkey/HotkeyComponentUtils.ts';
import { showAlertDialogAsync } from '@/wrappers/ShowAlertDialogAsync.ts';
import { useSessionStore } from '@/stores/SessionStore.ts';

export const hideAppAction = async () => {
    if (!window.electronApi) {
        return;
    }

    const settingsStore = useSettingsStore();
    if (settingsStore.hideWarningShown) {
        window.electronApi.hideApp();

        return;
    }

    const hideHotkey = getHotkeyLabel(Hotkey.ActionX3);

    const userConfirmed = await showAlertDialogAsync({
        title: 'The app will now enter hidden mode.',
        description: `You can press the hide hotkey (${hideHotkey}) to show the app again once you are done. We recommend pinning the app on top before hiding to make sure it appears on top again. This warning will only be shown once.`,
        actionText: 'Hide',
    });

    if (userConfirmed) {
        settingsStore.hideWarningShown = true;
        window.electronApi.hideApp();

        const sessionStore = useSessionStore();
        sessionStore.isContentProtectionEnabled = true;
    }
};
